import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M196 220h64v172",
      style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"40px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M187 396h138",
      style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"40px"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M256 160a32 32 0 1 1 32-32 32 32 0 0 1-32 32Z",
      style: {"fill":"currentColor","stroke":"currentColor"}
    }, null, -1)
  ]))]))
}
export default { render: render }